import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@bookdental/api";

export const trpc = createTRPCReact<AppRouter>();
